import buildIndicatorScopeKey from '@Application/Indicators/buildIndicatorScopeKey';
import type { IndicatorPeriod, IndicatorScope } from '@Application/Indicators/IndicatorScope';

/** Stable serialization of one indicator question (scope, period, optional document type). */
export default (scope: IndicatorScope, period: IndicatorPeriod, documentTypeId?: number | null): string => {
	return `${buildIndicatorScopeKey(scope)}|${period}|${documentTypeId ?? 'all'}`;
};
